import Vue from "vue";
import Router from "vue-router";
const Home = () => import("./Home");
const About = () => import("./About");
const Science = () => import("./Science");
const Ph2Supplement = () => import("./Ph2SupplementWrapper");

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "About Us",
      component: About
    },
    {
      path: "/science",
      name: "Science of Reading",
      component: Science
    },
    {
      path: "/StoryWriting",
      name: "Literacy Loom NSF SBIR Ph2 Supplement",
      component: Ph2Supplement
    },
    {
        path: '*',
        redirect: '/'
    }
  ]
});
